import { customFont } from '@honeybook/hbui/dist/styles/fonts';
import { ICompanyFont } from '~/types/model.types';

const FONTS_STYLE_TAG_ATTRIBUTE = 'fonts-style-tag';

export function getFontNameFromFile(fileName: string) {
    const name = fileName
        .split('.')[0]
        .replace(/[^-a-zA-Z_ ]/g, '')
        .replace(/ - /g, '-')
        .trim();

    return customFont[name] ? `${name} copy` : name;
}

export function getFontsStyleTag() {
    const fontsStyleTag = document.querySelector(
        `[${FONTS_STYLE_TAG_ATTRIBUTE}]`
    );
    return fontsStyleTag instanceof HTMLStyleElement ? fontsStyleTag : null;
}

export function createFontsStyleTag() {
    const head = document.head || document.getElementsByTagName('head')[0];
    const newFontsStyleTag = document.createElement('style');
    newFontsStyleTag.setAttribute('type', 'text/css');
    newFontsStyleTag.setAttribute(FONTS_STYLE_TAG_ATTRIBUTE, '');
    return head.appendChild(newFontsStyleTag);
}

export function getFontMarkdown(font: ICompanyFont) {
    return `
    @font-face {
        font-family: ${font.name};
        src: url('${font.url}');
    }
`;
}

export const loadGoogleFonts = (fontFamilies, isCss2 = true) => {
    const fontLink = document.createElement('link');
    fontLink.href = `https://fonts.googleapis.com/${
        isCss2 ? 'css2' : 'css'
    }?family=${fontFamilies}`;
    fontLink.rel = 'stylesheet';
    document.head.appendChild(fontLink);
};
